import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Juliet me ayudó a entender que pedir ayuda no es debilidad. Por primera vez sentí que alguien realmente me escuchaba.',
    author: 'Testimonio (ejemplo)'
  }, {
    text: 'Gracias a las sesiones de crianza, mi relación con mis hijos cambió completamente. Ahora tenemos mejor comunicación.',
    author: 'Testimonio (ejemplo)'
  }, {
    text: 'Un espacio seguro donde puedo hablar en mi idioma y sentirme comprendida. Lo recomiendo de corazón.',
    author: 'Testimonio (ejemplo)'
  }];
  return <section className="py-24 bg-white" data-id="element-219">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-220">
        <div className="text-center mb-16" data-id="element-221">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold text-gray-900 mb-4" data-id="element-222">
            Testimonios
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-223">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl border border-gray-200 relative" data-id="element-224">
              <Quote className="w-8 h-8 text-gray-300 mb-6" data-id="element-225" />
              <p className="text-gray-600 italic mb-6 leading-relaxed" data-id="element-226">
                "{testimonial.text}"
              </p>
              <p className="font-medium text-gray-900 text-sm uppercase tracking-wide" data-id="element-227">
                — {testimonial.author}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}